class UpdateInfo {
    constructor(template) {
        this.template = template;

        if(!this.template) return;

        this.setInfo();
    }

    setInfo() {
        const targetContainer = this.template.closest(".shopify-section").querySelector("[data-update-info-target]");
        const content = this.template.content;

        if (targetContainer) {
            if (!targetContainer.classList.contains("hidden")) {
                targetContainer.classList.add("hidden")
            }

            targetContainer.replaceChildren(...document.importNode(content, true).childNodes);

            if (targetContainer.classList.contains("hidden")) {
                targetContainer.classList.remove("hidden")
            }

            if (!targetContainer.classList.contains("animate")) {
                targetContainer.classList.add("animate")
            }

            setTimeout(() => {
                if (targetContainer.classList.contains("animate")) {
                    targetContainer.classList.remove("animate")
                }
            }, 500)
        }
    }
}